import React, { useState } from 'react';
import styles from './CustomSideMenu.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { logoutRdx } from '../../store/authSlice';
import CustomButton from '../customButton/CustomButton';
import CustomLoader from '../customLoader/CustomLoader';
import CustomLink from '../customLink/CustomLink';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/store';
import { userTypes } from '../../enums/userTypes.enum';

import { ReactComponent as IconInfo } from '../../assets/icons/g_icon_info.svg';
import { ReactComponent as IconEuro } from '../../assets/icons/g_icon_euro.svg';
import { ReactComponent as IconEstablishment } from '../../assets/icons/g_icon_establishment.svg';
import { ReactComponent as IconSchool } from '../../assets/icons/g_icon_school.svg';
import { ReactComponent as IconFile } from '../../assets/icons/g_icon_file.svg';
import { ReactComponent as IconUsers } from '../../assets/icons/g_icon_users.svg';
import { ReactComponent as IconHistory } from '../../assets/icons/g_icon_history.svg';
import { ReactComponent as IconDashboard } from '../../assets/icons/g_icon_dashboard.svg';
import { ReactComponent as IconLogout } from '../../assets/icons/g_icon_logout.svg';

const CustomSIdeMenu = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const userType = useSelector((state: RootState) => state.auth.userType);

    const [isLoading, setIsLoading] = useState(false);

    const sendLogout = async () => {
        setIsLoading(true);
        await dispatch(logoutRdx());
        setIsLoading(false);

        navigate('/login');
    }

    return (
        <div className={ styles.container }>
            <ul className={ styles.containerList }>
                <li><CustomLink isActive={ location.pathname === "/account" } to="/account"><IconInfo className={`${styles.nav_icon} ${location.pathname === "/account" && styles.is_active}`}/><span>{ t('side_menu.infos') }</span></CustomLink></li>
                <li><CustomLink isActive={ location.pathname === "/account/credits" } to="/account/credits"><IconEuro className={`${styles.nav_icon} ${location.pathname === "/account/credits" && styles.is_active}`}/><span>{ t('side_menu.credits') }</span></CustomLink></li>
                
                { userType === userTypes.ESTABLISHMENT &&
                    <li><CustomLink isActive={ location.pathname === "/account/my_members" } to="/account/my_members"><IconUsers className={`${styles.nav_icon} ${location.pathname === "/account/my_members" && styles.is_active}`}/><span>{ t('side_menu.my_members') }</span></CustomLink></li>
                }

                { userType === userTypes.DV &&
                    <>
                        <li><CustomLink isActive={ location.pathname === "/account/my_establishments" } to="/account/my_establishments"><IconEstablishment className={`${styles.nav_icon} ${location.pathname === "/account/my_establishments" && styles.is_active}`}/><span>{ t('side_menu.my_establishments') }</span></CustomLink></li>
                        <li><CustomLink isActive={ location.pathname === "/account/deri_academy" } to="/account/deri_academy"><IconSchool className={`${styles.nav_icon} ${location.pathname === "/account/deri_academy" && styles.is_active}`}/><span>{ t('side_menu.deri_academy') }</span></CustomLink></li>
                    </>
                }

                { userType === userTypes.EDITOR &&
                    <li><CustomLink isActive={ location.pathname === "/account/dashboard" } to="/account/dashboard"><IconDashboard className={`${styles.nav_icon} ${location.pathname === "/account/dashboard" && styles.is_active}`}/><span>{ t('side_menu.dashboard') }</span></CustomLink></li>
                }

                <li><CustomLink isActive={ location.pathname === "/account/projects" } to="/account/projects"><IconFile className={`${styles.nav_icon} ${location.pathname === "/account/projects" && styles.is_active}`}/><span>{ t('side_menu.projects') }</span></CustomLink></li>
                <li><CustomLink isActive={ location.pathname === "/account/download_history" } to="/account/download_history"><IconHistory className={`${styles.nav_icon} ${location.pathname === "/account/download_history" && styles.is_active}`}/><span>{ t('side_menu.download_history') }</span></CustomLink></li>
            </ul>

            <CustomButton className={styles.logoutBtn} onClick={() => { sendLogout() }}><IconLogout /><span>{ t('side_menu.logout') }</span></CustomButton>

            <CustomLoader isLoading={isLoading} />
        </div>
    );
}

export default CustomSIdeMenu; 